/**
 * classNames is the dotcom solution to constructing React component class strings for applying component styles.
 * @param {...(string|array|object|undefined)} args A collection of various data types used to construct the string
 * @returns A string constructed of all "truthy" arg values.
 * @example
 *
 *   classNames('foo', ['bar', 'baz'], { qux: true, quux: false });
 *   // returns 'foo bar baz qux'
 */

export function classNames(
  ...args: (string | string[] | Record<string, boolean> | undefined)[]
): string | undefined {
  const classes: string[] = [];

  args.forEach((arg) => {
    if (arg) {
      const argType = typeof arg;

      if (argType === "string") {
        classes.push(arg as string);
      } else if (Array.isArray(arg)) {
        const result = classNames(...arg);
        if (result) {
          classes.push(result);
        }
      } else if (argType === "object") {
        classes.push(...Object.keys(arg).filter((key) => (arg as Record<string, boolean>)[key]));
      }
    }
  });

  return classes.length > 0 ? classes.join(" ") : undefined;
}
